"use client"

import { Sparkles, Zap, Lock, Palette, Globe, Code } from "lucide-react"
import { useLanguage } from "@/contexts/language-context"

export function Features() {
  const { t } = useLanguage()

  const features = [
    {
      icon: <Sparkles className="h-6 w-6 text-amber-500" />,
      title: t("highQuality"),
      description: t("highQualityDesc"),
    },
    {
      icon: <Zap className="h-6 w-6 text-amber-500" />,
      title: t("fastResponse"),
      description: t("fastResponseDesc"),
    },
    {
      icon: <Lock className="h-6 w-6 text-amber-500" />,
      title: t("privacyProtection"),
      description: t("privacyProtectionDesc"),
    },
    {
      icon: <Palette className="h-6 w-6 text-amber-500" />,
      title: t("multipleStyles"),
      description: t("multipleStylesDesc"),
    },
    {
      icon: <Globe className="h-6 w-6 text-amber-500" />,
      title: t("globalAvailable"),
      description: t("globalAvailableDesc"),
    },
    {
      icon: <Code className="h-6 w-6 text-amber-500" />,
      title: t("apiAccess"),
      description: t("apiAccessDesc"),
    },
  ]

  return (
    <section id="features" className="w-full py-12 md:py-24 lg:py-32 bg-muted/30">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center justify-center space-y-4 text-center">
          <div className="space-y-2">
            <h2 className="text-3xl font-bold tracking-tighter sm:text-5xl">{t("featuresTitle")}</h2>
            <p className="max-w-[900px] text-muted-foreground md:text-xl">{t("featuresDesc")}</p>
          </div>
        </div>
        <div className="mx-auto grid max-w-5xl grid-cols-1 gap-6 py-12 md:grid-cols-2 lg:grid-cols-3">
          {features.map((feature, index) => (
            <div key={index} className="flex flex-col items-center space-y-2 rounded-lg border p-4 text-center">
              <div className="flex h-12 w-12 items-center justify-center rounded-full border bg-background">
                {feature.icon}
              </div>
              <h3 className="text-xl font-bold">{feature.title}</h3>
              <p className="text-sm text-muted-foreground">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
